/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Header, Icon, Button, Tab, Loader } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ClassScheduleTable,
  ClassScheduleForm,
} from "../../../components/Admin/ClassSchedule";
import { useAuth, usePermissions } from "../../../hooks";
import "./ClassSchedule.scss";
// import "./Student.scss";
import { Grade, AcademicCycle } from "../../../api";

const gradeController = new Grade();
const academicCycleController = new AcademicCycle();

export function ClassSchedule() {
  const { isSuperAdmin } = usePermissions();
  const [reload, setReload] = useState(false);
  const [academicCycle, setAcademicCycle] = useState(null);
  const { accessToken } = useAuth();
  const { academicCycleId } = useParams();
  const [grades, setGrades] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [activeGradeId, setActiveGradeId] = useState(null);

  const onReload = () => setReload((prevState) => !prevState);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const openCreateModal = (gradeId) => {
    setActiveGradeId(gradeId);
    setShowModal(true);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await academicCycleController.getAcademicCycle(
          academicCycleId
        );
        setAcademicCycle(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]);

  useEffect(() => {
    if (!academicCycle) return;
    (async () => {
      try {
        setGrades([]);
        const response = await gradeController.getGradesByLevelId(
          academicCycle.levelId,
          accessToken
        );
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycle, accessToken]);

  const panes = [];

  for (const grade of grades) {
    panes.push({
      menuItem: grade.name,
      render: () => (
        <Tab.Pane as="div" attached={false}>
          {isSuperAdmin && (
            <div style={{ marginBottom: "1em" }}>
              <Button
                primary
                onClick={() => openCreateModal(grade.id)}
                icon
                labelPosition="left"
              >
                <Icon name="plus" />
                Nuevo horario para {grade.name}
              </Button>
            </div>
          )}
          <ClassScheduleTable
            gradeId={grade.id}
            academicCycle={academicCycle}
            reload={reload}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    });
  }

  if (!academicCycle) return <Loader active inline="centered" />;

  return (
    <>
      <div className="class-schedule-page">
        <Header as="h3">
          <Icon name="calendar alternate" />
          <Header.Content>
            Horario de clases {academicCycle.name}
          </Header.Content>
        </Header>
        <Tab
          className="class-schedule-page__filters"
          menu={{ secondary: true }}
          panes={panes}
        />
      </div>
      <BasicModal
        size="small"
        show={showModal}
        close={onOpenCloseModal}
        title="Crear horario de clase"
      >
        <ClassScheduleForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          gradeId={activeGradeId}
          academicCycleId={academicCycle?.id}
        />
      </BasicModal>
    </>
  );
}
